$(function () {
    if ($("#rd-section-hr1").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-hr1",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-hr1").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-hr3").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-hr3",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-hr3").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-hr4").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-hr4",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-hr4").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-hr5").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-hr5",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-hr5").addClass("ani_do").removeClass("op0");
            },
        });
    }
    if ($("#rd-section-hr6").length > 0) {
        ScrollTrigger.create({
            trigger: "#rd-section-hr6",
            start: "top top+=80%",
            markers: false,
            onEnter: function () {
                $("#rd-section-hr6").addClass("ani_do").removeClass("op0");
            },
        });
    }
});
